import React from 'react';
import './index.css';
import { useNavigate } from 'react-router-dom';

import { getProductTypeDisplayName, getMainProductImage } from '../../utils/productUtils';
import { ProductType, Product, ProductImageType } from '../../context/CartContext';




// Sports

import product_sports_football_jersey_name_number_pendant1 from '../../assets/images/sports/product_sports_football_jersey_name_number_pendant1.webp';

// Locals
import localStreetSignOnFridge from '../../assets/images/locals/product_local_street_sign_on_fridge.webp';
import localCityLimitsOnFridge from '../../assets/images/locals/product_local_city_limits_Fayetteville_AR_on_fridge.webp';
import localStreetSignsImage from '../../assets/images/locals/product_local_street_sign_magnet_front_and_back.webp';
import localStreetSignCityLimitsImage from '../../assets/images/locals/product_local_sign_citylimits_Fayetteville_AR.webp';
import localStreetSignsSummary from '../../assets/images/locals/product_local_street_sign_summary.webp';
import localStreetSignCityLimitsYourCity from '../../assets/images/locals/product_local_sign_citylimits_yourcity.webp';

// SnapCharms
const product_default_snapcharm = '/images/bogo-violet-sale.webp';

const Shop: React.FC = () => {
  const navigate = useNavigate();

  const handleSnapCharmsClick = () => {
    navigate('/shop/snapcharms');
  };

  const handleSportsClick = () => {
    navigate('/shop/sports');
  };

  const handleLocalsClick = () => {
    navigate('/shop/locals');
  };

  return (
    <div className="shop-container">      
      {/* Category Cards */}
      <div className="products-grid">
        <div className="product-card" onClick={handleSnapCharmsClick}>
          <h2 className="product-name">{getProductTypeDisplayName(ProductType.SNAPCHARM)}</h2>
          <div className="product-image-wrapper">
            <img 
              src={product_default_snapcharm} 
              alt="SnapCharms Collection" 
              className="product-image" 
            />
          </div>
          <div className="product-info">
            <p className="product-description">Browse our collection of adorable SnapCharms</p>
            <div className="product-video-link">
              <a 
                href="https://youtu.be/7KoZewZRuic" 
                target="_blank" 
                rel="noopener noreferrer"
                className="video-link"
              >
                Watch Video
              </a>
            </div>
            <div className="product-actions">
              <button onClick={handleSnapCharmsClick}>
                View Collection
              </button>
            </div>
          </div>
        </div>
        
        <div className="product-card" onClick={handleSportsClick}>
          <h2 className="product-name">{getProductTypeDisplayName(ProductType.SPORTS)}</h2>
          <div className="product-image-wrapper">
            <img 
              src={product_sports_football_jersey_name_number_pendant1} 
              alt="Sports Collection" 
              onClick={handleSportsClick}
              className="product-image" 
            />
          </div>
          <div className="product-info">
            <p className="product-description">Customize with your name, number, and team name !</p>
            <div className="product-actions">
              <button onClick={handleSportsClick}>
                View Collection
              </button>
            </div>
          </div>
        </div>
        
        <div className="product-card" onClick={handleLocalsClick}>
          <h2 className="product-name">Locally Themed Products</h2>
          <div className="product-image-wrapper locals-images">
            <div className="locals-image-container">
              <img 
                src={localStreetSignsSummary} 
                alt="Local Signs" 
                className="locals-image" 
              />
            </div>
          </div>
          <div className="product-info">
            <p className="product-description">Street Signs with authentic samples from the local area.  Choose from a wide selection or even customize your own !</p>
            <div className="product-actions">
              <button onClick={handleLocalsClick}>
                View Collection
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Print Request Section */}
      <div className="custom-print-section">
        <h2>Don't See What You're Looking For?</h2>
        <p>Email us with your customization request for a 3D printed item. It can be a jewelry, a magnet, or virtually any concept we can work on together!</p>
        <a href="mailto:sales@hogcloud.net" className="custom-print-link">
          Request Customized Print!
        </a>
      </div>

    </div>
  );
};

export default Shop;

